import store from '../stores';
import { sessionRefreshed } from '../stores/authenticated';

export type SyncSessionMetadataOptions = {
  /**
   * false のとき Redux は更新しない。ログイン直後は user がまだ Redux に無いため、
   * ここで sessionRefreshed すると Header 等が null 参照で落ちる。
   */
  syncRedux?: boolean;
};

/**
 * サーバーが Set-Cookie した httpOnly トークンに合わせ、有効期限メタデータを Redux に反映する。
 */
export function syncSessionMetadata(
  accessTokenExpiresAt: number,
  options?: SyncSessionMetadataOptions,
): void {
  if (options?.syncRedux !== false) {
    store.dispatch(sessionRefreshed({ accessTokenExpiresAt }));
  }
}
